<template>
  <div class="main">
    <toptab></toptab>
    <div class="newwhiteouter">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <!-- 指示符 -->
        <ul class="carousel-indicators" style="bottom:-70px">
          <template v-for="(item,index) in projectbanner">
            <!-- <li data-target="#demo" :data-slide-to="index" class="active" :key="index"></li> -->
            <!-- style="width:10px;height:10px;border-radius:50%;" -->
            <li data-target="#demo" :data-slide-to="index" :class="index==0? 'active':'' " :key="index"></li>
          </template>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <template v-for="(item,index) in projectbanner">
            <div
              class="carousel-item"
              :class="index==0? 'active':'' "
              :key="index"
              :style="'background: #fff url('+item.image+') center center no-repeat;'"
            >
              <div class="text paddingallllll">
                <div class="textitle animated fadeInUp">
                  <b>{{item.title}}</b>
                </div>
                <div class="textinfo animated fadeInUp">{{item.line}}</div>
                <!-- <div class="textimg animated fadeInUp">
                  <a href="javascript:void(0);">
                    <img src="/static/index/more2.png" />
                  </a>
                </div>-->
              </div>
              <div class="blackcover"></div>
            </div>
          </template>
        </div>
        <!-- 左右切换按钮 -->
        <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev" style="z-index:40">
          <img src="/static/左箭头.png" style="width:60px;height:70px" />
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next" style="z-index:40">
          <img src="/static/右箭头.png" style="width:60px;height:70px" />
        </a>-->
      </div>
    </div>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="maintitle animated fadeInUp" id="firsttitle">
          <b>公司介绍</b>
        </div>
        <div class="firstmain">
          <div class="firstimg animated fadeInUp">
            <img :src="introduction.image" alt />
          </div>
          <div v-html="introduction.introduction" class="firstinfoinfo animated fadeInUp"></div>
        </div>
      </div>
    </div>
    <div class="mainouter grayback paddingall">
      <div class="firstinfo">
        <div class="maintitle" id="secondtitle">
          <b>企业文化</b>
        </div>
        <div class="mapmain">
          <div class="mapimg">
            <img :src="culture.image" alt class="cultureimage" />
            <img :src="culture.cover" alt class="culturecover" />
            <div class="appoint a1">
              <div class="i"></div>
            </div>
            <div class="appoint a2">
              <div class="i"></div>
            </div>
            <div class="appoint a3">
              <div class="i"></div>
            </div>
            <div class="appoint a4">
              <div class="i"></div>
            </div>
          </div>
          <div class="mapinfoinfo">
            <div class="culturetitle">{{culture.title}}</div>
            <div class="culturesubtitle">{{culture.subtitle}}</div>
            <div v-html="culture.contents" class="mapinfo"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bodythree paddingall">
      <div class="threelist">
        <div class="threeitem">
          <div class="threetitle">
            <span id="numberone"></span>
          </div>
          <div class="threeinfo">
            <b>管理人员</b>
          </div>
          <div class="threeinfotwo">优质的质量与细节</div>
        </div>
        <div class="threeitem">
          <div class="threetitle">
            <span id="numbertwo"></span>
          </div>
          <div class="threeinfo">
            <b>质检人员</b>
          </div>
          <div class="threeinfotwo">长年经验与技术的沉淀</div>
        </div>
        <div class="threeitem">
          <div class="threetitle">
            <span id="numberthree"></span>+
          </div>
          <div class="threeinfo">
            <b>公司员工</b>
          </div>
          <div class="threeinfotwo">优秀人才与强大技术</div>
        </div>
        <div class="threeitem">
          <div class="threetitle">
            <span id="numberfour"></span>
          </div>
          <div class="threeinfo">
            <b>工程师</b>
          </div>
          <div class="threeinfotwo">专业技术与成熟经验</div>
        </div>
      </div>
    </div>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="maintitle" id="thirdtitle">
          <b>发展历程</b>
        </div>
        <el-carousel :interval="5000" arrow="always" height="4rem" id="first">
          <template v-for="(item,index) in register">
            <el-carousel-item :key="index" class="firstitem">
              <template v-for="(_item,_index) in register[index]">
                <div :key="_index" class="registeritem">
                  <div class="registeritemtitle">
                    <b>{{_item.year}}</b>
                  </div>
                  <div class="registeriteminfo">{{_item.event}}</div>
                  <div class="registerline"></div>
                </div>
              </template>
            </el-carousel-item>
          </template>
        </el-carousel>
      </div>
    </div>
    <div class="mainouter grayback paddingall">
      <div class="firstinfo">
        <div class="maintitle" id="fourtitle">
          <b>荣誉资质</b>
        </div>
        <el-carousel :interval="5000" arrow="always" height="6rem" id="second">
          <template v-for="(item,index) in honors">
            <el-carousel-item :key="index" class="seconditem">
              <template v-for="(_item,_index) in honors[index]">
                <img :src="_item.image" alt :key="_index" />
              </template>
            </el-carousel-item>
          </template>
        </el-carousel>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import footeritem from "../components/footer-item";
export default {
  components: {
    toptab,
    footeritem,
  },
  data() {
    return {
      projectbanner: [],
      data: [],
      introduction: "",
      culture: "",
      register: [],
      honors: [],
      honorssmall: [],
      defhonors: [],
      registersmall: [],
      defregister: []
    }
  },
  beforeCreate() {
    if (window.isFirst) {
      // window.location.reload()
    }
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/about');
      this.$e.$on("smallWindow", () => {
        console.log("11111");
        this.honors = this.honorssmall
        this.register = this.registersmall
      })
      this.$e.$on("bigWindow", () => {
        console.log("2222");
        this.honors = this.defhonors
        this.register = this.defregister
      })
    })
  },

  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.getAboutUsBanner, {})
        .then(res => {
          console.log(res.data);
          let { error_code, banners } = res.data;
          if (error_code == 2001) {
            this.projectbanner = banners
          }
        });
      this.$axios.post(this.$url.getIntro, {})
        .then(res => {
          console.log(res.data);
          let { error_code, introduction } = res.data;
          if (error_code == 2001) {
            this.introduction = introduction
          }
        });
      this.$axios.post(this.$url.getCulture, {})
        .then(res => {
          console.log(res.data);
          let { error_code, culture } = res.data;
          if (error_code == 2001) {
            this.culture = culture
          }
        });
      this.$axios.post(this.$url.getHistory, {})
        .then(res => {
          console.log(res.data);
          let { error_code, histories } = res.data;
          if (error_code == 2001) {
            // let register = [];
            // for (var i = 0, len = histories.length; i < len; i += 3) {
            //   register.push(histories.slice(i, i + 3));
            // }
            // this.register = register
            let register = [];
            for (var i = 0, len = histories.length; i < len; i += 3) {
              register.push(histories.slice(i, i + 3));
            }
            let registersmall = []
            for (var it = 0, lent = histories.length; it < lent; it += 2) {
              registersmall.push(histories.slice(it, it + 2));
            }
            this.register = register
            this.defregister = register
            this.registersmall = registersmall
            console.log(register, registersmall);
          }
        });
      this.$axios.post(this.$url.getHonor, {})
        .then(res => {
          console.log(res.data);
          let { error_code, honors } = res.data;
          if (error_code == 2001) {
            let honorss = [];
            for (var i = 0, len = honors.length; i < len; i += 10) {
              honorss.push(honors.slice(i, i + 10));
            }
            let honorssmall = []
            for (var it = 0, lent = honors.length; it < lent; it += 6) {
              honorssmall.push(honors.slice(it, it + 6));
            }
            this.honors = honorss
            this.defhonors = honorss
            this.honorssmall = honorssmall
            console.log(this.honors, this.honorssmall);
          }
        });
      this.$axios.post(this.$url.getEmployee)
        .then(res => {
          console.log(res.data);
          let { error_code, employee } = res.data;
          if (error_code == 2001) {
            setTimeout(() => {
              let valuees = {
                valuee: { v: employee.manage_num, s: employee.manage_speed },
                valuee2: { v: employee.quality_num, s: employee.quality_speed },
                valuee3: { v: employee.worker_num, s: employee.worker_speed },
                valuee4: { v: employee.engineer_num, s: employee.engineer_speed },
              }
              localStorage.setItem('valuees', JSON.stringify(valuees))
            }, 500);
          }
        })
    },
  }
}
</script>
<style>
.el-carousel__arrow:focus {
  outline: none !important;
}
.el-carousel__arrow:hover {
  background-color: rgba(255, 105, 0, 1);
}
.el-carousel__arrow--right {
  right: 0;
}
.el-carousel__arrow {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 56px;
  width: 56px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 39px;
}

.el-carousel__arrow--left {
  left: 0;
}
.el-carousel__indicators--horizontal {
  display: none;
}
</style>

<style scoped>
@import "../css/animate.min.css";
@import "../css/padding.css";
.main {
  padding-top: 0.67rem;
}

#demo {
  width: 1920px;
  height: 492px;
  margin: 0 auto;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner {
  width: 100%;
  height: 492px;
  /* position: relative; */
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner .carousel-item {
  padding-top: 1rem;
  width: 100%;
  height: 492px;
  background-size: cover;
  /* max-height: 1080px;
  min-height: 8.6rem; */
  position: relative;
}
#demo .carousel-inner .text {
  width: 1440px;
  /* margin: 0 auto; */
  font-size: 40px;
  color: white;
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#demo .carousel-inner .text .textitle {
}

#demo .carousel-inner .text .textinfo {
}

/* #demo .carousel-inner .text .textimg {
  width: 1.8rem;
  height: 0.46rem;
  margin-top: 1.5rem;
}

#demo .carousel-inner .text .textimg img {
  width: 1.8rem;
  height: 0.46rem;
} */

.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
}

.textitle {
  font-size: 0.6rem;
  margin-bottom: 0.58rem;
  text-align: center;
}
.textinfo {
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.4rem;
}

.newwhiteouter {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 492px;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}

.mainouter {
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}

.maintitle {
  font-size: 0.4rem;
  height: 0.4rem;
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin-bottom: 0.4rem;
}
.firstmain {
  display: flex;
  justify-content: space-between;
}
.firstimg {
  width: 35%;
}
.firstimg img {
  width: 100%;
}
.mapimg {
  width: 680px;
  padding-top: 3%;
  position: relative;
}
.mapimg img {
  width: 680px;
}
.firstinfoinfo {
  width: 55%;
  font-size: 0.2rem;
}

.mapinfo {
  width: 100%;
  font-size: 0.16rem;
  color: #8f8f8f;
}
.mapmain {
  display: flex;
  justify-content: space-between;
}
.mapinfoinfo {
  width: 100%;
  max-width: 40%;
}
.bodythree {
  width: 100%;
  /* height: 3.14rem; */
  background: #fff url(../../static/aboutmid.png) center center no-repeat;
  /* padding: 0.2rem 0; */
  background-size: cover;
}

.threelist {
  width: 1440px;
  height: 3.14rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 0 auto;
  /* padding: 0 0.4rem; */
  flex-wrap: wrap;
}
.threeitem {
  width: 25%;
  text-align: center;
  /* height: 1.1rem; */
  margin: auto 0;
  color: white;
}
.threetitle {
  font-size: 0.5rem;
  height: 0.5rem;
  margin-bottom: 0.3rem;
  font-weight: 600;
}
.threeinfo {
  font-size: 0.2rem;
  margin-bottom: 10px;
}
.threeinfotwo {
  font-size: 0.15rem;
}
.culturetitle {
  font-size: 0.3rem;
  margin-bottom: 0.1rem;
}
.culturesubtitle {
  margin-bottom: 0.1rem;
  font-size: 0.2rem;
}
.firstitem {
  background-color: #fff;
  display: flex;
  padding: 1rem 5%;
  width: 100%;
}

.registeritem {
  width: 33.3%;
  padding: 0.4rem 0.2rem;
  font-size: 0.18rem;
  position: relative;
}
.registeritemtitle {
  font-size: 0.5rem;
}
.registeriteminfo {
  color: #616161;
  font-size: 0.18rem;
}
.registeritem + .registeritem .registerline {
  border-left: 1px solid #f6f6f6;
  position: absolute;
  left: -1px;
  height: 0.8rem;
  top: 0.8rem;
}

.seconditem {
  background-color: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  padding: 0 5%;
  width: 100%;
}
.seconditem img {
  width: 12%;
  margin: 4%;
  max-height: 190px;
}
.appoint {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff6900;
  /* display: flex;
  justify-content: center; */
  align-items: center;
  position: relative;
}
.appoint .i {
  position: absolute;
  top: -15px;
  left: -15px;
  /* flex: 0 0 40px; */
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 105, 0, 0.4);
  border: 1px solid #ff6900;
  animation: scalemap 2s linear infinite;
  -moz-animation: scalemap 2s linear infinite;
  -webkit-animation: scalemap 2s linear infinite;
}
.a1 {
  position: absolute;

  top: 40%;
  left: 15%;
}

.a2 {
  position: absolute;

  top: 23%;
  left: 30%;
}

.a3 {
  position: absolute;

  top: 42%;
  left: 46%;
}

.a4 {
  position: absolute;

  top: 39%;
  left: 74%;
}
.culturecover {
  display: none;
}
@keyframes scalemap {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  100% {
    opacity: 0;
    transform: scale(1.6);
  }
}
@media (max-width: 1440px) {
  .threelist {
    width: 100%;
  }
  #demo .carousel-inner .text {
    width: 100%;
  }
  .mapimg {
    width: 660px;
  }
  .mapimg img {
    width: 660px;
  }
}

@media (max-width: 1200px) {
  .culturecover {
    display: block;
  }
  .cultureimage {
    display: none;
  }
  .appoint {
    display: none;
  }
}

@media (max-width: 992px) {
  .main {
    padding-top: 100px;
  }

  .mapmain {
    flex-direction: column;
  }
  .mapimg {
    width: 100%;
  }
  .mapimg img {
    width: 100%;
  }
  .mapinfoinfo {
    max-width: 100%;
    margin-top: 0.4rem;
  }
  .firstinfoinfo {
    font-size: 0.14rem;
  }
  /* .threeitem {
    width: 40%;
  } */
  .seconditem img {
    width: 20%;
    margin: 6.5%;
  }

  .threelist {
    padding: 0;
  }
  .maintitle {
    font-size: 60px;
    line-height: 60px;
    height: 60px;
  }
  .firstinfoinfo {
    width: 100%;
    font-size: 30px;
  }
  .culturetitle {
    font-size: 50px;
  }
  .culturesubtitle {
    font-size: 40px;
  }
  .mapinfo {
    font-size: 30px;
  }
  .threetitle {
    font-size: 80px;
    line-height: 70px;
  }
  .threeinfo {
    /* margin-top: 20px; */
    line-height: 70px;
    font-size: 40px;
  }
  .threeinfotwo {
    display: none;
    font-size: 18px;
  }
  .bodythree {
    padding-left: 0.4rem !important;
    padding-right: 0.4rem !important;
  }
  .registeritemtitle {
    font-size: 60px;
  }
  .registeriteminfo {
    font-size: 30px;
  }
  .firstitem {
    padding: 0.4rem 6%;
    justify-content: space-between;
  }

  .firstimg {
    display: none;
  }
  .textinfo {
    font-size: 0.4rem;
  }

  .registeritem {
    width: 46%;
    padding: 0.4rem 0.2rem;
    /* font-size: 0.18rem; */
    position: relative;
  }
}
@media (max-width: 1920px) {
  #demo {
    width: 100%;
  }

  #topdemo {
    width: 100%;
  }
  /* .firstinfo {
    max-width: 100%;
  } */
}

@media (max-width: 1300px) {
  #demo .carousel-inner .carousel-item {
    padding-top: 1.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue